import { Box } from '@/shared/ui/box';
import { SkeletonLoader } from '@/shared/ui/skeleton';

export const HistorySkeleton = () =>
  [1, 2]?.map((history) => {
    return (
      <Box $paddingBottom={12} key={history}>
        <Box $flex="1" $width="80px" key={history} $margin="0 auto 8px">
          <SkeletonLoader height={23} />
        </Box>
        <Box $display="flex" $flexDirection="column" $gap={8}>
          {[3, 4, 5]?.map((history) => {
            return (
              <Box $flex="1" key={history}>
                <SkeletonLoader height={75} />
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  });
